import { render } from "./ProfileButton.vue?vue&type=template&id=905c4980&scoped=true"
import script from "./ProfileButton.vue?vue&type=script&lang=js"
export * from "./ProfileButton.vue?vue&type=script&lang=js"

import "./ProfileButton.vue?vue&type=style&index=0&id=905c4980&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905c4980"]])

export default __exports__